import React, { useEffect, useState } from "react";
import PageHeader, {
  BreadcrumbsModel,
} from "../../../../../shared/PageHeader/PageHeader";
import PageWrapper from "../../../../../shared/PageWrapper/PageWrapper";
import Button from "../../../../../components/Button/Button";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Box, Card, CardContent, Grid2, Typography } from "@mui/material";
import EligiblityComparisonCommonTable from "./EligiblityComparisonCommonTable";
import GeneralQualification from "./../../../MasterSetting/PositionMaster/PositionMasterEligibility/GeneralQualification/GeneralQualification";
import API from "../../../../../api/axios";
import DataLoader from "../../../../../shared/DataLoader/DataLoader";
import DataNotFound from "../../../../../shared/DataNotFound/DataNotFound";

const breadcrumbs: BreadcrumbsModel[] = [
  { name: "Interview Tracker", route: "/admin/interview-tracker" },
  { name: "Eligibility Comparison" },
];

const ageLimitTableHeader = {
  headerColumns: ["S.No", "Age Limit Criteria", "Max Marks", "Candidate Marks"],
};

const gendralQualificationHeader = {
  headerColumns: [
    "S.No",
    "General Qualification Criteria",
    "Max Marks",
    "Candidate Marks",
  ],
};

const adequencyForTheProjectHeader = {
  headerColumns: [
    "S.No",
    "Adequency For The Project Criteria",
    "Max Marks",
    "Candidate Marks",
  ],
};

const EligiblityComparision = () => {
  const navigate = useNavigate();
  const params = useParams();
  const state = useLocation();
  const [eligiblityComparisionData, setEligiblityComparisionData] =
    useState<any>([]);
  const [eligiblityData, setEligiblityData] = useState<any>({});
  const [eligiblityLoding, setEligiblityLoading] = useState<boolean>(false);
  const [consolidatedMarks, setConsolidatedMarks] = useState({});

  let getEligibilityComparision = async () => {
    setEligiblityLoading(true);
    try {
      let responce = await API.post("/eligibility/view/candidate/comparison", {
        candidate_id: params?.candidate_id,
        position_eligibility_id: params?.position_eligibility_id,
      });
      setEligiblityComparisionData(responce?.data?.data);
    } catch (err) {
      // Failed to fetch eligibility comparison data
    } finally {
      setEligiblityLoading(false);
    }
  };
  useEffect(() => {
    getEligibilityComparision();
  }, []);

  useEffect(() => {
    let res: any = {};
    if (eligiblityComparisionData) {
      eligiblityComparisionData?.map((data: any, value: any) => {
        if (!res[data?.eligibility_master_id?.type]) {
          res[data?.eligibility_master_id?.type] = [];
        }
        res[data?.eligibility_master_id?.type]?.push({
          description: data?.eligibility_master_id?.title,
          max_marks: data?.max_marks,
          candidate_marks: data?.candidate_marks,
          sort: data?.eligibility_master_id?.sort,
          subText: data?.eligibility_master_id?.description,
        });
      });
    }
    let result: any = Object.entries(res).map(([key, value]: any) => {
      return {
        [key]: value?.sort((a: any, b: any) => a.sort - b.sort),
      };
    });
    const resultObject = result?.reduce((acc: any, item: any) => {
      const key = Object.keys(item)[0];
      acc[key] = item[key];
      return acc;
    }, {});
    setEligiblityData(resultObject);
  }, [eligiblityComparisionData]);

  const combinedName = (firstName: any, lastName: any) => {
    if (!firstName) {
      return "NA";
    }
    return `${firstName} ${lastName}`;
  };

  useEffect(() => {
    let totalCandidateMarks = 0;
    let totalMaxMarks = 0;

    Object.keys(eligiblityData).forEach((key) => {
      eligiblityData[key].forEach((item: any) => {
        totalCandidateMarks += parseFloat(item.candidate_marks || 0);
        totalMaxMarks += parseFloat(item.max_marks || 0);
      });
    });
    const conslidatedPercentage = (totalCandidateMarks / totalMaxMarks) * 100;
    setConsolidatedMarks({
      totalCandidateMarks: totalCandidateMarks,
      totalMaxMarks: totalMaxMarks,
      consolidatedPercentage: conslidatedPercentage,
    });
  }, [eligiblityData]);

  return (
    <PageWrapper>
      <PageHeader
        breadcrumbs={state?.state?.breadCrumbs || breadcrumbs}
        title="Eligibility Comparison"
      >
        <Button
          variant="secondary"
          variantType="contained"
          label="Back"
          onClick={() => {
            state.state?.filterState?.id
              ? navigate("/admin/interview-tracker", {
                  state: state?.state,
                })
              : navigate(-1);
          }}
        />
      </PageHeader>
      <Box>
        {eligiblityLoding ? (
          <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
            <CardContent sx={{ padding: { xs: 0, md: "16px" } }}>
              <Box height={"450px"} sx={{ textAlign: "center" }}>
                <DataLoader />
              </Box>
            </CardContent>
          </Card>
        ) : eligiblityComparisionData?.length > 0 ? (
          <>
            <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
              <CardContent sx={{ padding: { xs: 0, md: "16px" } }}>
                <Grid2 container spacing={2}>
                  <Grid2 size={{ xs: 12, sm: 6, md: 4.5 }}>
                    <Typography variant="body1">Position Title</Typography>
                    <Typography variant="subtitle2">
                      {eligiblityComparisionData?.[0]?.position_id?.name ||
                        "NA"}
                    </Typography>
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <Typography variant="body1">Candidate Name</Typography>
                    <Typography variant="subtitle2">
                      {combinedName(
                        eligiblityComparisionData?.[0]?.candidate_id
                          ?.first_name,
                        eligiblityComparisionData?.[0]?.candidate_id?.last_name,
                      )}
                    </Typography>
                  </Grid2>
                </Grid2>
              </CardContent>
            </Card>

            <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
              <CardContent sx={{ padding: { xs: 0, md: "16px" } }}>
                {/* <GeneralQualification/> */}
                {eligiblityData["age_limit"] && (
                  <Box>
                    <Box
                      marginBottom={3}
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography
                        sx={{
                          fontSize: "18px",
                          fontWeight: "600",
                          letterSpacing: "0.3px",
                          color: "#202224",
                        }}
                      >
                        Age Limit
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "15px",
                          color: "#202224",
                          fontWeight: "400",
                        }}
                      >
                        {/* {"Note : Candidate Age on submission of quer "} */}
                      </Typography>
                    </Box>

                    <EligiblityComparisonCommonTable
                      tableHeader={ageLimitTableHeader}
                      tableData={eligiblityData["age_limit"]}
                    />
                  </Box>
                )}
                {eligiblityData["gen_qualification"] && (
                  <Box sx={{ marginTop: "30px" }}>
                    <Box
                      marginBottom={3}
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography
                        sx={{
                          fontSize: "18px",
                          fontWeight: "600",
                          letterSpacing: "0.3px",
                          color: "#202224",
                        }}
                      >
                        General Qualification
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "15px",
                          color: "#202224",
                          fontWeight: "400",
                        }}
                      ></Typography>
                    </Box>

                    <EligiblityComparisonCommonTable
                      tableHeader={gendralQualificationHeader}
                      tableData={eligiblityData["gen_qualification"]}
                    />
                  </Box>
                )}
                {eligiblityData["project_adequation"] && (
                  <Box sx={{ marginTop: "30px" }}>
                    <Box
                      marginBottom={3}
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography
                        sx={{
                          fontSize: "18px",
                          fontWeight: "600",
                          letterSpacing: "0.3px",
                          color: "#202224",
                        }}
                      >
                        Adquency For The Project
                      </Typography>
                    </Box>

                    <EligiblityComparisonCommonTable
                      tableHeader={adequencyForTheProjectHeader}
                      tableData={eligiblityData["project_adequation"]}
                      consolidatedData={consolidatedMarks}
                    />
                  </Box>
                )}
              </CardContent>
            </Card>
          </>
        ) : (
          <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
            <CardContent sx={{ padding: { xs: 0, md: "16px" } }}>
              <Box height={"450px"} sx={{ textAlign: "center" }}>
                <DataNotFound />
              </Box>
            </CardContent>
          </Card>
        )}
      </Box>
    </PageWrapper>
  );
};

export default EligiblityComparision;
